export * from './lib/attribute.service.module';

export { AccredibleAttributeService } from './lib/attribute.service';
export { DEFAULT_ATTRIBUTES } from './lib/default-attributes';
